module.exports = __webpack_public_path__ + "media/images/emblems/Savigny-coat_of_arms-99c0ba23cd7a0e2355504f3b8718aa94.svg";